import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import FlyoutModal from '../common/FlyoutModal';
import styles from './AlternativeProductWrapper.module.scss';
import Checkbox from '../common/Checkbox';
import useDrupalSettings from '../../hooks/useDrupalSettings';
import { priceToString } from '../../utils';

const AlternativeProductWrapper = ({
  id,
  isChecked,
  onChecked,
  alternativeProduct,
  altVariantToShow,
}) => {
  const { formatMessage, formatNumber, locale } = useIntl();
  const [isModalOpen, setModalOpen] = useState(false);

  const { product: productFromDrupalSettings } = useDrupalSettings();

  const onCheckboxChange = useCallback(
    (productId) => {
      onChecked(productId);
    },
    [onChecked],
  );

  return (
    <>
      {isModalOpen && (
        <FlyoutModal
          isVisible={isModalOpen}
          onCloseModal={() => setModalOpen(false)}
          backButtonLabel={productFromDrupalSettings?.name}
        >
          {alternativeProduct?.product?.description[locale]}
        </FlyoutModal>
      )}
      <div className={styles['add-headboard-container']}>
        <Checkbox
          name={id}
          id={id}
          checked={isChecked}
          onChange={() => onCheckboxChange(id)}
          label={
            <div className={styles['add-headboard-message']}>
              {altVariantToShow?.price &&
                alternativeProduct.prefixMessage?.[locale]?.replace(
                  '__PRICE__',
                  priceToString({
                    price: altVariantToShow?.price,
                    formatMessage,
                    formatNumber,
                  }),
                )}
            </div>
          }
        />
      </div>
    </>
  );
};
AlternativeProductWrapper.propTypes = {
  id: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onChecked: PropTypes.func.isRequired,
  altVariantToShow: PropTypes.shape({
    attributes: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }),
    ).isRequired,
    discount: PropTypes.shape({
      type: PropTypes.string,
      currencyCode: PropTypes.string,
      centAmount: PropTypes.number.isRequired,
      fractionDigits: PropTypes.number.isRequired,
    }),
    id: PropTypes.number.isRequired,
    key: PropTypes.string.isRequired,
    masterVariant: PropTypes.bool,
    price: PropTypes.shape({
      type: PropTypes.string,
      currencyCode: PropTypes.string,
      centAmount: PropTypes.number.isRequired,
      fractionDigits: PropTypes.number.isRequired,
    }),
    sku: PropTypes.string.isRequired,
  }).isRequired,
  alternativeProduct: PropTypes.shape({
    prefixMessage: PropTypes.string.isRequired,
    product: PropTypes.shape({
      productId: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      productType: PropTypes.string.isRequired,
      variants: PropTypes.arrayOf(
        PropTypes.shape({
          attributes: PropTypes.arrayOf(
            PropTypes.shape({
              name: PropTypes.string.isRequired,
              key: PropTypes.string.isRequired,
              label: PropTypes.string.isRequired,
            }),
          ).isRequired,
          discount: PropTypes.string,
          id: PropTypes.number.isRequired,
          key: PropTypes.string.isRequired,
          masterVariant: PropTypes.bool,
          price: PropTypes.string.isRequired,
          sku: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }).isRequired,
  }).isRequired,
};

export default AlternativeProductWrapper;
